// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Drawer overlay - Dark backdrop with low opacity */
.s_b81S {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1001;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;
  border: none;
  padding: 0;
  margin: 0;
}

/* Drawer container - Slides in from the right */
.KF5TUj {
  position: fixed;
  top: 0;
  right: 0;
  height: 100dvh;
  width: 400px;
  background-color: #ffffff;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1002;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

@media (max-width: 400px) {
  .KF5TUj {
    width: 100vw;
  }
}

/* Drawer states */
.H96O5P {
  transform: translateX(100%);
}

.VSigX4 {
  transform: translateX(0);
}

/* Drawer content */
.aRWeqR {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Drawer header */
.bxg0bG {
  margin-top: 6px;
  padding: var(--spacing-2) var(--spacing-2) var(--spacing-1);
}

.mBSm_W {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.u6csVF {
  display: flex;
  gap: var(--spacing-1);
  align-items: center;
}

.FrwIm8 {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-xl);
}

.QIkZSd {
  margin-left: var(--spacing-5);
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
}

.M9UNGn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.M9UNGn:hover {
  background-color: #f5f5f5;
  color: #333;
}

.M9UNGn:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

/* Drawer body */
.RWIP1d {
  display: flex;
  flex-grow: 1;
  padding: 20px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Drawer/Drawer.module.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,aAAa;EACb,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,2CAA2C;EAC3C,aAAa;EACb,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qDAAqD;EACrD,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ;;mBAEiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["/* Drawer overlay - Dark backdrop with low opacity */\n.drawer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100dvh;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 1001;\n  opacity: 1;\n  transition: opacity 0.3s ease-in-out;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Drawer container - Slides in from the right */\n.drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100dvh;\n  width: 400px;\n  background-color: #ffffff;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  z-index: 1002;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n@media (max-width: 400px) {\n  .drawer {\n    width: 100vw;\n  }\n}\n\n/* Drawer states */\n.drawer-closed {\n  transform: translateX(100%);\n}\n\n.drawer-open {\n  transform: translateX(0);\n}\n\n/* Drawer content */\n.drawer-content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Drawer header */\n.drawer-header-container {\n  margin-top: 6px;\n  padding: var(--spacing-2) var(--spacing-2) var(--spacing-1);\n}\n\n.drawer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.drawer-header-left {\n  display: flex;\n  gap: var(--spacing-1);\n  align-items: center;\n}\n\n.drawer-header-title {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-xl);\n}\n\n.drawer-header-subtitle {\n  margin-left: var(--spacing-5);\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n}\n\n.drawer-close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  transition:\n    background-color 0.2s ease,\n    color 0.2s ease;\n}\n\n.drawer-close-btn:hover {\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n.drawer-close-btn:focus {\n  outline: 2px solid #007bff;\n  outline-offset: 2px;\n}\n\n/* Drawer body */\n.drawer-body {\n  display: flex;\n  flex-grow: 1;\n  padding: 20px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer-overlay": `s_b81S`,
	"drawerOverlay": `s_b81S`,
	"drawer": `KF5TUj`,
	"drawer-closed": `H96O5P`,
	"drawerClosed": `H96O5P`,
	"drawer-open": `VSigX4`,
	"drawerOpen": `VSigX4`,
	"drawer-content": `aRWeqR`,
	"drawerContent": `aRWeqR`,
	"drawer-header-container": `bxg0bG`,
	"drawerHeaderContainer": `bxg0bG`,
	"drawer-header": `mBSm_W`,
	"drawerHeader": `mBSm_W`,
	"drawer-header-left": `u6csVF`,
	"drawerHeaderLeft": `u6csVF`,
	"drawer-header-title": `FrwIm8`,
	"drawerHeaderTitle": `FrwIm8`,
	"drawer-header-subtitle": `QIkZSd`,
	"drawerHeaderSubtitle": `QIkZSd`,
	"drawer-close-btn": `M9UNGn`,
	"drawerCloseBtn": `M9UNGn`,
	"drawer-body": `RWIP1d`,
	"drawerBody": `RWIP1d`
};
module.exports = ___CSS_LOADER_EXPORT___;
